import {NavLink} from "react-router-dom";
import {Customer} from "../types.ts";

export const CustomerLink = (props: { record: Customer }) => {
    return <NavLink to={`/customers/${props.record.id}`}>{props.record.name}</NavLink>
}